import {
  QueryParamsState,
  QueryStateActionType,
  QueryStateActions,
} from "./types";

export const initialState: QueryParamsState = {
  insurance_name: "",
  date_from: "",
  date_to: "",
  pagination: true,
  sort_by: "id",
  direction: "desc",
  page: 1,
  insurance_state:"",
  insurance_type:"", 
  product:"", 
  cpt_codes:"", 
  insurance_mac:"", 
  doctor_taxonomy:""
};

export const queryParamReducer = (
  state: QueryParamsState,
  action: QueryStateActionType
): QueryParamsState => {
  switch (action.type) {
    case QueryStateActions.CHANGE_INSURANCE_NAME:
      return {
        ...state,
        insurance_name: action.payload,
      };
      case QueryStateActions.CHANGE_INSURANCE_MAC:
      return {
        ...state,
        insurance_mac: action.payload,
      };
      case QueryStateActions.CHANGE_INSURANCE_TYPE:
      return {
        ...state,
        insurance_type: action.payload,
      };
      case QueryStateActions.CHANGE_INSURANCE_STATE:
      return {
        ...state,
        insurance_state: action.payload,
      };
      case QueryStateActions.CHANGE_CPT_CODES:
      return {
        ...state,
        cpt_codes: action.payload,
      };
      case QueryStateActions.CHANGE_DOCTOR_TAXONOMY:
      return {
        ...state,
        doctor_taxonomy: action.payload,
      };
      case QueryStateActions.CHANGE_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case QueryStateActions.CHANGE_FROM_DATE:
      return {
        ...state,
        date_from: action.payload,
      };

    case QueryStateActions.CHANGE_TO_DATE:
      return {
        ...state,
        date_to: action.payload,
      };
    case QueryStateActions.CHANGE_PAGE:
      return {
        ...state,
        page: action.payload
      };
    case QueryStateActions.CHANGE_PAGINATION_BIT:
      return {
        ...state,
        pagination: action.payload,
      };
    case QueryStateActions.CHANGE_SORT_PARAMS:
      return {
        ...state,
        sort_by: action.payload.sort_by,
        direction: action.payload.direction,
      };
    case QueryStateActions.CLEAR_STATE:
      return initialState;
    default:
      return state;
  }
};